<template>
  <ul class="menu-list">
    <li v-for="(item, index) in menu.list" :key="index" class="menu-list__item">
      <div :menu-route="item.route"
           :title="item.title"
           class="menu-list__link"
           @click.prevent="switchMenu"
      >
        <div class="section-icon"
             :style="{background: item.colorSecond, background: `linear-gradient(90deg, ${item.colorFirst} -35.71%, ${item.colorSecond} 142.86%)`}">
          <div class="section-icon__img">
            <img :src="item.icon" :alt="item.title">
          </div>
        </div>
        <p class="menu-list__text">{{ item.title }}</p>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'AppMenuListMain',
  computed: {
    menu () {
      return this.$store.getters.mainMenu
    }
  },
  methods: {
    switchMenu (event) {
      const menu = event.currentTarget.getAttribute('menu-route')
      this.$store.dispatch('switchMenu', { menu, isSubmenu: false })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.menu-list {
  animation: fadeIn .3s ease-in;

  &__link {
    display: flex;
    flex-flow: row nowrap;
    align-items: center;
    padding: 5px 15px;
    transition: .3s;
    color: $font_color_alt;
    cursor: pointer;

    &:hover {
      background-color: $color_second-light;

      .section-icon {
        box-shadow: none;
      }
    }
  }

  &__text {
    margin-left: 20px;
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap
  }
}
</style>
